import axios from 'axios'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dropdown from '~components/ui/Dropdown'
import RoundedIcon from '~components/ui/RoundedIcon'
import Link from './ui/Link'
import PropTypes from 'prop-types'

const copyrightDate = new Date().getFullYear()
class Footer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      stockist: {},
      columns: [],
      bottomLinks: []
    }
  }

  componentDidMount () {
    axios.get('/options', {
      params: {
        option: 'footer'
      }
    })
      .then(response => {
        this.setState({
          columns: response.data.fields.footer_cols,
          bottomLinks: response.data.fields.bottom_links
        })
      })
  }

  showBrandsWhenSuspended (heading = '') {
    const title = heading.toLowerCase()
    const isBrandsTitle = title === 'brands'
    return isBrandsTitle && this.props.isSuspended
  }

  processLinks (links) {
    return links.map(link => {
      return {
        key: link.key,
        title: link.attributes.label,
        url: link.attributes.link,
        display_for: link.attributes?.display_for ?? null
      }
    })
  }

  /**
   * Check if the link should be displayed based on the stockist's office number
   *
   * @param link
   * @returns {boolean}
   */
  shouldDisplayLink (link) {
    const { stockist } = this.props
    return (
      link.display_for === null ||
      link.display_for === 'all' ||
      stockist?.office_number === link.display_for
    )
  }

  /**
   * Check if the column should be displayed based on the stockist's office number
   *
   * @param column
   * @returns {boolean}
   */
  shouldDisplayColumn (column) {
    const { stockist } = this.props
    return (
      column.attributes.display_for === null ||
      column.attributes.display_for === 'all' ||
      stockist?.office_number === column.attributes.display_for
    )
  }

  render () {
    return (
      <div className="w-full py-10 border-t border-coral xl:py-20">
        <div className="px-4 mx-auto xxl:container md:px-8 xxl:px-0">
          <div className="flex flex-col flex-wrap items-center -mx-2 -my-4 md:items-start md:flex-row lg:-mx-4 xl:-mx-5">
            {this.state.columns.map(column => {
              return !this.showBrandsWhenSuspended(column.attributes.heading) && this.shouldDisplayColumn(column) && (
                <div key={column.key} className="w-full px-2 my-4 sm:w-2/3 md:w-1/2 lg:w-1/4 lg:px-4 xl:px-5">
                  <Dropdown
                    label={column.attributes.heading}
                    title={column.attributes.heading}
                    links={this.processLinks(column.attributes.links)}
                    classNames="md:hidden"
                  />

                  <h3 className="hidden pb-1 border-b border-coral md:block">
                    {column.attributes.heading}
                  </h3>

                  <ul className="hidden w-full mt-5 md:block">
                    {this.processLinks(column.attributes.links)
                      .filter(link => this.shouldDisplayLink(link))
                      .map(link => (
                        <li key={link.key}>
                          <Link href={link.url} className="hover:underline">
                            {link.title}
                          </Link>
                        </li>
                      ))}
                  </ul>

                </div>
              )
            })}
          </div>

          <div className="flex flex-wrap mt-10 md:flex-col-reverse md:border-coral md:border-t md:pt-4 lg:flex-row-reverse lg:flex-no-wrap lg:items-start">
            <a href="mailto:info@panache-lingerie.com" className="inline-flex items-center flex-grow-0 flex-shrink-0 mx-auto mb-10 group md:mt-4 md:mx-0 md:mb-0 lg:mt-0 lg:ml-4">
              <RoundedIcon name="label" className="inline-block mr-2 w-7 h-7" />
              Need help?
            </a>

            <ul className="flex-wrap w-full -mb-3 text-center md:w-auto md:inline-flex md:text-left md:-mb-1 lg:mr-auto">
              <li className="hidden mb-3 md:mb-1 md:mr-3 md:block">
                &copy; Panache
                {' '}
                {copyrightDate}
              </li>
              {this.state.bottomLinks
                .filter((link) => this.shouldDisplayLink(link.attributes))
                .map(link => (
                  <li key={link.key} className="block mb-3 md:mb-1 md:mr-6">
                    <Link href={link.attributes.link} className="hover:underline">
                      {link.attributes.label}
                    </Link>
                  </li>
                ))}
              <li className="block mb-3 md:mb-1 md:mr-3 md:hidden">
                &copy; Panache
                {' '}
                {copyrightDate}
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

Footer.propTypes = {
  stockist: PropTypes.object,
  accountStatus: PropTypes.string,
  isSuspended: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    stockist: state.auth.account.stockist,
    isSuspended: state.auth.isSuspended
  }
}

export default connect(mapStateToProps)(Footer)
